<script setup>
import { ModuleManager } from "@module-system";

// this page does nothing but to have a warmup time for the app to load necessary resources

var bgBlurModule = ModuleManager.getModules().filter((x) => x.name === "BgBlurReplacement");
if (bgBlurModule.length > 0) {
  let mod = bgBlurModule[0];
  let bgBlurParams = mod.getBgBlurParams();
  mod.bgBlur(bgBlurParams);
}
</script>

<template>
  <div>
    <!-- Empty warmup page -->
  </div>
</template>
